const $ = require('jquery')

let mobile = false
const mobiles = /(iP(hone|ad|od)|Android|webOS|BlackBerry|Windows Phone)/i

if (
  (navigator.userAgent.match(mobiles) || // matching userAgent names
    'ontouchstart' in document.documentElement) && // detectiong if device has touch events
  navigator.userAgent.indexOf('PhantomJS') === -1 // phantomJS has touch events
) {
  mobile = true
}

window.MOBILE = mobile

// eslint-disable-next-line no-console
console.log(mobile ? 'MOBILE' : 'NOT MOBILE')

if (document.body) {
  document.body.className += mobile ? ' mobile' : ' desktop'
} else {
  $(() => {
    document.body.className += mobile ? ' mobile' : ' desktop'
  })
}

module.exports = mobile
